export default {"src":"/_next/static/media/kitchen.5e226224.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};